import {Injectable} from '@angular/core';
import {MatomoInjector, MatomoTracker} from 'ngx-matomo';
import {environment} from '@env/environment';

@Injectable()
export class UserTrackingService {

  constructor(protected matomoInjector: MatomoInjector,
              protected matomoTracker: MatomoTracker) {
//
  }

  public init() {
    this.matomoInjector.init(environment.matomoUrl, environment.matomoId);
  }

  public setUserid(name: string) {
    this.matomoTracker.setUserId(name);
  }

  public async getVisitorId(): Promise<string> {
    const vistitorId: string = await this.matomoTracker.getVisitorId();

    return vistitorId;
  }


  public resetUserId() {
    this.matomoTracker.resetUserId();
  }

  public trackEvent(category: string, action: string, name?: string, value?: number) {
    this.matomoTracker.trackEvent(category, action, name, value);
  }

  public setDocumentTitle(title: string) {
    this.matomoTracker.setDocumentTitle(title);
  }

  public trackPageView(title?: string) {
    this.matomoTracker.setCustomUrl(this.getCurrentUrl());
    this.matomoTracker.trackPageView(title);
  }

  protected getCurrentUrl(): string {
    return window.location.href;
  }

}
